export default function Django_Add_Link_To_Details() {
  return <div>Django_Add_Link_To_Details Component</div>;
}
